import { useRouter } from 'nextjs-toploader/app'
import { Icon } from 'shared/iconpack'
import { TokenStorage } from 'shared/libs/storage'

import { MouseEvent } from 'react'

import {
  useDeleteSearchQueryMutation,
  useGetSearchQueriesQuery,
  useSetSearchQueryMutation,
} from 'modules/Search/model/api'
import { SearchQueryItem } from 'modules/Search/model/types'

import { Button } from 'shared/ui/button'

import { ROUTER_PATHS } from 'shared/config/routerPath/RouterPath'
import { globalStyles } from 'shared/config/styles/globalStyles'

import styles from './Searchtem.module.scss'

interface SearchQueryItemProps {
  id: SearchQueryItem['pk']
  label: SearchQueryItem['query']
  withDelete?: boolean
  isMobile?: boolean
}

export function SearchItem({
  id,
  label,
  withDelete = true,
  isMobile = false,
}: SearchQueryItemProps) {
  const token = TokenStorage.getFromStorage()
  const [deleteQuery] = useDeleteSearchQueryMutation()
  const { refetch } = useGetSearchQueriesQuery()
  const [setQuery] = useSetSearchQueryMutation()
  const router = useRouter()

  const handleSearch = async () => {
    if (!withDelete && !!token) await setQuery({ query: label })
    router.replace(
      isMobile
        ? ROUTER_PATHS.search.getWithAutoComplete(encodeURIComponent(label))
        : ROUTER_PATHS.catalogBySearch.get(encodeURIComponent(label)),
    )
  }

  const deleteHandle = async (e: MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    await deleteQuery(String(id))
    refetch()
  }

  return (
    <Button
      onClick={handleSearch}
      variant="additional"
      fullWidth
      className={styles.query}
    >
      <span className={styles.queryLabel}>{label}</span>
      {withDelete && (
        <div onClick={deleteHandle} className={styles.delete}>
          <Icon
            name="close"
            size={16}
            color={globalStyles['--icon-secondary']}
          />
        </div>
      )}
    </Button>
  )
}
